
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_933Fbtj9lhmXMeta } from "/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/[...slug].vue?macro=true";
import { default as _91slug_93zNKnsXEft5Meta } from "/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/business-councils/[slug].vue?macro=true";
import { default as indexjkVoxxqbD8Meta } from "/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/business-councils/index.vue?macro=true";
import { default as _91slug_930Iy7ttbUs2Meta } from "/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/committees/[slug].vue?macro=true";
import { default as indexDp0E6hOE57Meta } from "/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/committees/index.vue?macro=true";
import { default as indexApwJ4KdjuGMeta } from "/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/index.vue?macro=true";
import { default as medewerkershQKn7ouizMMeta } from "/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/medewerkers.vue?macro=true";
import { default as _91slug_93KiGq0h8oQmMeta } from "/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/networking-clubs/[slug].vue?macro=true";
import { default as indexfvn9Nl5oSoMeta } from "/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/networking-clubs/index.vue?macro=true";
import { default as _91slug_938eWMCKXfsjMeta } from "/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/networking-groups/[slug].vue?macro=true";
import { default as indexQdRMqwHRGCMeta } from "/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/networking-groups/index.vue?macro=true";
import { default as _91slug_93aG6NvCf7E0Meta } from "/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/vacancies/[slug].vue?macro=true";
import { default as _91slug_93WzEkYyBzAmMeta } from "/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/ambitions/[ambition]/[slug].vue?macro=true";
import { default as indexdHBBPyvFlNMeta } from "/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/ambitions/[ambition]/index.vue?macro=true";
import { default as indexFOy1XrpJd4Meta } from "/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/ambitions/index.vue?macro=true";
import { default as contact4n8PrAP9CXMeta } from "/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/contact.vue?macro=true";
import { default as _91slug_93Ij3c1uTYujMeta } from "/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/events/[slug].vue?macro=true";
import { default as indexP1ZZyG6sJSMeta } from "/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/events/index.vue?macro=true";
import { default as indexYy3QRGGRMTMeta } from "/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/index.vue?macro=true";
import { default as _91slug_93jZ702PbjkZMeta } from "/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/members/[slug].vue?macro=true";
import { default as indexEEdbBsgYEMMeta } from "/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/members/index.vue?macro=true";
import { default as _91slug_93JoiV81xc6pMeta } from "/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/news/[slug].vue?macro=true";
import { default as indexNNnRYrMvpoMeta } from "/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/news/index.vue?macro=true";
import { default as searchv7gDwcEWrAMeta } from "/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/search.vue?macro=true";
export default [
  {
    name: "slug___nl",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_933Fbtj9lhmXMeta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_933Fbtj9lhmXMeta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/[...slug].vue")
  },
  {
    name: "slug___de",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_933Fbtj9lhmXMeta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/[...slug].vue")
  },
  {
    name: "about-us-business-councils-slug___nl",
    path: "/over-ons/business-councils/:slug()",
    meta: _91slug_93zNKnsXEft5Meta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/business-councils/[slug].vue")
  },
  {
    name: "about-us-business-councils-slug___en",
    path: "/about-us/business-councils/:slug()",
    meta: _91slug_93zNKnsXEft5Meta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/business-councils/[slug].vue")
  },
  {
    name: "about-us-business-councils-slug___de",
    path: "/uber-uns/unternehmensrate/:slug()",
    meta: _91slug_93zNKnsXEft5Meta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/business-councils/[slug].vue")
  },
  {
    name: "about-us-business-councils___nl",
    path: "/over-ons/business-councils",
    meta: indexjkVoxxqbD8Meta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/business-councils/index.vue")
  },
  {
    name: "about-us-business-councils___en",
    path: "/about-us/business-councils",
    meta: indexjkVoxxqbD8Meta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/business-councils/index.vue")
  },
  {
    name: "about-us-business-councils___de",
    path: "/uber-uns/unternehmensrate",
    meta: indexjkVoxxqbD8Meta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/business-councils/index.vue")
  },
  {
    name: "about-us-committees-slug___nl",
    path: "/over-ons/comites/:slug()",
    meta: _91slug_930Iy7ttbUs2Meta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/committees/[slug].vue")
  },
  {
    name: "about-us-committees-slug___en",
    path: "/about-us/committees/:slug()",
    meta: _91slug_930Iy7ttbUs2Meta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/committees/[slug].vue")
  },
  {
    name: "about-us-committees-slug___de",
    path: "/uber-uns/aussch%C3%BCsse/:slug()",
    meta: _91slug_930Iy7ttbUs2Meta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/committees/[slug].vue")
  },
  {
    name: "about-us-committees___nl",
    path: "/over-ons/comites",
    meta: indexDp0E6hOE57Meta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/committees/index.vue")
  },
  {
    name: "about-us-committees___en",
    path: "/about-us/committees",
    meta: indexDp0E6hOE57Meta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/committees/index.vue")
  },
  {
    name: "about-us-committees___de",
    path: "/uber-uns/aussch%C3%BCsse",
    meta: indexDp0E6hOE57Meta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/committees/index.vue")
  },
  {
    name: "about-us___nl",
    path: "/over-ons",
    meta: indexApwJ4KdjuGMeta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/index.vue")
  },
  {
    name: "about-us___en",
    path: "/about-us",
    meta: indexApwJ4KdjuGMeta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/index.vue")
  },
  {
    name: "about-us___de",
    path: "/uber-uns",
    meta: indexApwJ4KdjuGMeta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/index.vue")
  },
  {
    name: "about-us-medewerkers___nl",
    path: "/over-ons/medewerkers",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/medewerkers.vue")
  },
  {
    name: "about-us-medewerkers___en",
    path: "/about-us/employees",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/medewerkers.vue")
  },
  {
    name: "about-us-medewerkers___de",
    path: "/uber-uns/personal",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/medewerkers.vue")
  },
  {
    name: "about-us-networking-clubs-slug___nl",
    path: "/over-ons/netwerkclubs/:slug()",
    meta: _91slug_93KiGq0h8oQmMeta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/networking-clubs/[slug].vue")
  },
  {
    name: "about-us-networking-clubs-slug___en",
    path: "/about-us/networking-clubs/:slug()",
    meta: _91slug_93KiGq0h8oQmMeta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/networking-clubs/[slug].vue")
  },
  {
    name: "about-us-networking-clubs-slug___de",
    path: "/uber-uns/networking-clubs/:slug()",
    meta: _91slug_93KiGq0h8oQmMeta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/networking-clubs/[slug].vue")
  },
  {
    name: "about-us-networking-clubs___nl",
    path: "/over-ons/netwerkclubs",
    meta: indexfvn9Nl5oSoMeta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/networking-clubs/index.vue")
  },
  {
    name: "about-us-networking-clubs___en",
    path: "/about-us/networking-clubs",
    meta: indexfvn9Nl5oSoMeta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/networking-clubs/index.vue")
  },
  {
    name: "about-us-networking-clubs___de",
    path: "/uber-uns/networking-clubs",
    meta: indexfvn9Nl5oSoMeta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/networking-clubs/index.vue")
  },
  {
    name: "about-us-networking-groups-slug___nl",
    path: "/over-ons/netwerkgroepen/:slug()",
    meta: _91slug_938eWMCKXfsjMeta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/networking-groups/[slug].vue")
  },
  {
    name: "about-us-networking-groups-slug___en",
    path: "/about-us/networking-groups/:slug()",
    meta: _91slug_938eWMCKXfsjMeta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/networking-groups/[slug].vue")
  },
  {
    name: "about-us-networking-groups-slug___de",
    path: "/uber-uns/netzwerkgruppen/:slug()",
    meta: _91slug_938eWMCKXfsjMeta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/networking-groups/[slug].vue")
  },
  {
    name: "about-us-networking-groups___nl",
    path: "/over-ons/netwerkgroepen",
    meta: indexQdRMqwHRGCMeta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/networking-groups/index.vue")
  },
  {
    name: "about-us-networking-groups___en",
    path: "/about-us/networking-groups",
    meta: indexQdRMqwHRGCMeta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/networking-groups/index.vue")
  },
  {
    name: "about-us-networking-groups___de",
    path: "/uber-uns/netzwerkgruppen",
    meta: indexQdRMqwHRGCMeta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/networking-groups/index.vue")
  },
  {
    name: "about-us-vacancies-slug___nl",
    path: "/over-ons/vacatures/:slug()",
    meta: _91slug_93aG6NvCf7E0Meta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/vacancies/[slug].vue")
  },
  {
    name: "about-us-vacancies-slug___en",
    path: "/about-us/vacancies/:slug()",
    meta: _91slug_93aG6NvCf7E0Meta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/vacancies/[slug].vue")
  },
  {
    name: "about-us-vacancies-slug___de",
    path: "/uber-uns/Stellenangebote/:slug()",
    meta: _91slug_93aG6NvCf7E0Meta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/about-us/vacancies/[slug].vue")
  },
  {
    name: "ambitions-ambition-slug___nl",
    path: "/ambities/:ambition()/:slug()",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/ambitions/[ambition]/[slug].vue")
  },
  {
    name: "ambitions-ambition-slug___en",
    path: "/ambitions/:ambition()/:slug()",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/ambitions/[ambition]/[slug].vue")
  },
  {
    name: "ambitions-ambition-slug___de",
    path: "/ambitionen/:ambition()/:slug()",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/ambitions/[ambition]/[slug].vue")
  },
  {
    name: "ambitions-ambition___nl",
    path: "/ambities/:ambition()",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/ambitions/[ambition]/index.vue")
  },
  {
    name: "ambitions-ambition___en",
    path: "/ambitions/:ambition()",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/ambitions/[ambition]/index.vue")
  },
  {
    name: "ambitions-ambition___de",
    path: "/ambitionen/:ambition()",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/ambitions/[ambition]/index.vue")
  },
  {
    name: "ambitions___nl",
    path: "/ambities",
    meta: indexFOy1XrpJd4Meta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/ambitions/index.vue")
  },
  {
    name: "ambitions___en",
    path: "/ambitions",
    meta: indexFOy1XrpJd4Meta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/ambitions/index.vue")
  },
  {
    name: "ambitions___de",
    path: "/ambitionen",
    meta: indexFOy1XrpJd4Meta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/ambitions/index.vue")
  },
  {
    name: "contact___nl",
    path: "/contact",
    meta: contact4n8PrAP9CXMeta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/contact",
    meta: contact4n8PrAP9CXMeta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/contact.vue")
  },
  {
    name: "contact___de",
    path: "/kontakt",
    meta: contact4n8PrAP9CXMeta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/contact.vue")
  },
  {
    name: "events-slug___nl",
    path: "/agenda/:slug()",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/events/[slug].vue")
  },
  {
    name: "events-slug___en",
    path: "/events/:slug()",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/events/[slug].vue")
  },
  {
    name: "events-slug___de",
    path: "/veranstaltungen/:slug()",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/events/[slug].vue")
  },
  {
    name: "events___nl",
    path: "/agenda",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/events/index.vue")
  },
  {
    name: "events___en",
    path: "/events",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/events/index.vue")
  },
  {
    name: "events___de",
    path: "/ereignisse",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/events/index.vue")
  },
  {
    name: "index___nl",
    path: "/",
    meta: indexYy3QRGGRMTMeta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/",
    meta: indexYy3QRGGRMTMeta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/",
    meta: indexYy3QRGGRMTMeta || {},
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/index.vue")
  },
  {
    name: "members-slug___nl",
    path: "/leden/:slug()",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/members/[slug].vue")
  },
  {
    name: "members-slug___en",
    path: "/members/:slug()",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/members/[slug].vue")
  },
  {
    name: "members-slug___de",
    path: "/mitglieder/:slug()",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/members/[slug].vue")
  },
  {
    name: "members___nl",
    path: "/leden",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/members/index.vue")
  },
  {
    name: "members___en",
    path: "/members",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/members/index.vue")
  },
  {
    name: "members___de",
    path: "/mitglieder",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/members/index.vue")
  },
  {
    name: "news-slug___nl",
    path: "/nieuws/:slug()",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/news/[slug].vue")
  },
  {
    name: "news-slug___en",
    path: "/news/:slug()",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/news/[slug].vue")
  },
  {
    name: "news-slug___de",
    path: "/nachrichten/:slug()",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/news/[slug].vue")
  },
  {
    name: "news___nl",
    path: "/nieuws",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/news/index.vue")
  },
  {
    name: "news___en",
    path: "/news",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/news/index.vue")
  },
  {
    name: "news___de",
    path: "/nachrichten",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/news/index.vue")
  },
  {
    name: "search___nl",
    path: "/zoeken",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/search.vue")
  },
  {
    name: "search___en",
    path: "/search",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/search.vue")
  },
  {
    name: "search___de",
    path: "/s%C3%BCchen",
    component: () => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/pages/search.vue")
  }
]